module.exports = __webpack_public_path__ + "static/img/errenmj_banner.cfa8fda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/errenmj_banner.png
// module id = EyRZ
// module chunks = 0